import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { CareCommentId } from "../../../domain/care_comment/CareCommentId";
import { CareCommentThreadId } from "../../../domain/care_comment/CareCommentThreadId";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { getCareCommentList, markAsReadCareComment, pinCareComment, unpinCareComment } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/CareComment",
    getList: "getList",
    resetCareComment: "resetCareComment",
    markAsRead: "markAsRead",
    pin: "pin",
    unpin: "unpin"
});

export const getCareCommentListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async(careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getCareCommentList(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);

export const resetCareCommentAction = createAction(`${ActionType.base}/${ActionType.resetCareComment}`);

export const markAsReadCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.markAsRead}`,
    async(careCommentIdList: CareCommentId[]) => {
        await markAsReadCareComment(careCommentIdList);

        return { careCommentIdList: careCommentIdList.map(careCommentId => careCommentId.value) };
    }
);

export const pinCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.pin}`,
    async (careCommentThreadId: CareCommentThreadId) => {
        await pinCareComment(careCommentThreadId);

        return { careCommentThreadId: careCommentThreadId.value };
    }
);

export const unpinCareCommentAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.unpin}`,
    async (careCommentThreadId: CareCommentThreadId) => {
        await unpinCareComment(careCommentThreadId);

        return { careCommentThreadId: careCommentThreadId.value };
    }
);